import { render, staticRenderFns } from "./JdsFieldRow.vue?vue&type=template&id=f4cef94a&scoped=true&"
import script from "./JdsFieldRow.vue?vue&type=script&lang=ts&"
export * from "./JdsFieldRow.vue?vue&type=script&lang=ts&"
import style0 from "./JdsFieldRow.vue?vue&type=style&index=0&id=f4cef94a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4cef94a",
  null
  
)

export default component.exports